import type { SVGProps } from 'react';

type ArrowRightIconProps = {
    width?: number | string;
    height?: number | string;
    color?: string;
    className?: string;
    svgProps?: SVGProps<SVGSVGElement>;
};

const ShopArrowRightIcon = ({ width = 16, height = 26, color = 'currentColor', className = '', svgProps }: ArrowRightIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 26" fill="none" className={className} {...svgProps}>
            <path d="M3.09833 0L0 2.78778L9.56944 12.6028L0 23.1978L3.09833 26L15.1883 12.6172L3.09833 0Z" fill={color} />
        </svg>
    );
};

export default ShopArrowRightIcon;
